import { IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const arrowSx = {
  zIndex: 10,
  backgroundColor: "transparent",
  border: "1px solid #2A48764F",
  "&:hover": { backgroundColor: "transparent" },
  boxShadow: "none",
};

export default function CarouselArrowButtons({
  onPrev,
  onNext,
  className = "arrow-icon-custom arrow-icon-edit",
  offset = "-15px",
}) {
  return (
    <>
      <IconButton
        className={className}
        onClick={onPrev}
        sx={{
          ...arrowSx,
          position: "absolute",
          left: offset,
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>
      <IconButton
        className={className}
        onClick={onNext}
        sx={{
          ...arrowSx,
          position: "absolute",
          right: offset,
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </>
  );
}
